import { type AbortPageProps } from '../../../chulak/ChulakSession';
import { getAbortVariant } from '../../../utils/abortVariants';
import { useQrOnScreen } from '../../../hooks/useQrOnScreen';
import EmbeddedAbortScreen from '../shared/AbortScreen';
import EmbeddedExpiredQrScreen from '../shared/ExpiredQrScreen';
import EmbeddedTimeoutScreen from './TimeoutScreen';

/** Errors in the drawer. An expired request fades the QR code only when it was on screen. */
export default function EmbeddedMobileAbortPage(props: AbortPageProps) {
  const { shown } = useQrOnScreen();
  const variant = props.variant ?? getAbortVariant(props.errorCode);
  if (props.app && variant === 'expired') {
    return shown ? (
      <EmbeddedExpiredQrScreen
        onRefresh={props.onRestart}
        onBack={props.onBack}
      />
    ) : (
      <EmbeddedTimeoutScreen onRetry={props.onRestart} onBack={props.onBack} />
    );
  }
  return <EmbeddedAbortScreen {...props} />;
}
